"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background: ", ";\n  border-radius: ", ";\n  overflow: hidden;\n  box-shadow: ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  right: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  background: ", ";\n  cursor: pointer;\n  transform: ", ";\n  transition: transform 0.25s ease-in-out;\n  position: relative;\n  .footer-right {\n    position: relative;\n    left: ", ";\n    transition: left 0.25s ease-in-out;\n  }\n  &:hover {\n    transform: scale(1.02);\n    .footer-right {\n      left: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeCard = exports.ActionContainer = exports.Card = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

exports.Card = styled_components_1["default"].div(_templateObject(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@background-color-base'];
}, function (props) {
  return props.hovering ? 'scale(1.02)' : 'scale(1)';
}, function (props) {
  return props.hovering ? props.theme['@size-xxs'] : '0';
}, function (props) {
  return props.theme['@size-xxs'];
});
exports.ActionContainer = styled_components_1["default"].div(_templateObject2(), function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-s'];
});
exports.LargeCard = styled_components_1["default"].div(_templateObject3(), function (props) {
  return props.theme['@gray-0'];
}, function (props) {
  return props.theme['@border-radius-large'];
}, function (props) {
  return props.theme['@shadow-large'];
});